/* global $:true */
import plugin from '../../lib/plugin';
import { onAvailable } from "../../lib/selectors";

const ELEMENT_SELECTOR = '[data-swatch-row]';
const PLUGIN_NAME = 'swatchRow';

export function exec() {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--swatch-row" */ "./swatch-row"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/swatch-row/index.js